import React from "react";
import PropTypes from "prop-types";
import {
  change,
  Field,
  formValueSelector,
  getFormInitialValues
} from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/ManagedRepairOrders/actions";
import {
  AutoCompleteField,
  form,
  Form as AppForm,
  FormInput,
  Select
} from "MODULES/shared/components/Forms";
import CompanyAddressWarning from "MODULES/shared/components/CompanyAddressWarning";
import { COMPANY_ID, CONTACT_ID, FOB, PAYMENT_TERMS } from "APP_ROOT/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import LocationRadioField from "MODULES/Locations/components/BuyingStoreRadioField";
import {
  CompanyStatsTooltip,
  DashedSeparator
} from "MODULES/shared/components";
import { APPROVAL_STATUSES, WEBSITE } from "MODULES/companies/constants";
import { properCase } from "LIB/formatters/text";
import { PORTAL_PURCHASE } from "MODULES/PurchaseOrders/constants";
import _, { get } from "lodash";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import { searchContacts } from "MODULES/parts/actions";
import {
  contactSelectList,
  selectPrimaryContact
} from "MODULES/companies/helpers";
import PaymentTerms from "MODULES/shared/components/PaymentTerms/PaymentTerms";
import validate from "./validate";

const formName = "editMroVendorDetails";

export class Form extends React.Component {
  state = {
    contacts: []
  };

  componentWillMount() {
    if (
      this.props.managedRepairOrder &&
      this.props.managedRepairOrder.company
    ) {
      this.fetchContacts(this.props.managedRepairOrder.company.id);
    }
  }

  setPaymentTerms = val => {
    this.props.setFieldValue(PAYMENT_TERMS)(val);
  };

  fetchContacts = value => {
    if (!value) {
      return null;
    }

    return searchContacts(value).then((vals = []) => {
      this.setState({ contacts: vals });

      if (this.props.setPrimaryContact) {
        selectPrimaryContact(vals, this.props.setField(CONTACT_ID));
      }
    });
  };

  handleCompanyChange = result => {
    if (this.props.setSelectedCompany) this.props.setSelectedCompany(result);

    if (this.props.notifyForm) this.props.notifyForm(result);

    if (result) {
      const address = result.primary_physical_address;
      const formattedAddress = address
        ? [address.city, address.state, address.country].join("-")
        : "";
      this.props.setFieldValue(FOB)(formattedAddress);
      if (this.props.setPaymentTerms)
        this.props.setPaymentTerms(result.vendor_credit_terms);
      this.fetchContacts(result.id);
    } else {
      this.setState({ contacts: [] });
    }
  };

  notifyForm = company => this.setState({ company });

  render() {
    const {
      contact,
      managedRepairOrder,
      searchCompanies,
      getInitialFieldValue
    } = this.props;
    const { selectedCompany, contacts } = this.state;

    const options = contactSelectList(contacts, true);
    const company =
      selectedCompany || (managedRepairOrder && managedRepairOrder.company);

    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          <CompanyAddressWarning company={company} />
          <div>
            <MultiLocationFeature>
              <FormRow>
                <Col md={5}>
                  <LocationRadioField label="Managing Store" />
                </Col>
              </FormRow>
              <DashedSeparator />
            </MultiLocationFeature>
            <FormRow>
              <Col md={6}>
                <Field
                  name={COMPANY_ID}
                  label="Vendor"
                  labelChildren={
                    company && (
                      <React.Fragment>
                        <CompanyStatsTooltip company={company} />
                      </React.Fragment>
                    )
                  }
                  placeholder="Search by typing a company's name or code"
                  component={AutoCompleteField}
                  search={searchCompanies}
                  formatItem={result =>
                    `${result.name} (${APPROVAL_STATUSES[result.vendor_status]
                      .label})`}
                  onItemSelected={i => i && this.handleCompanyChange(i)}
                  selectedItem={company}
                  required
                />
              </Col>
              <Col md={3}>
                <Field
                  name={CONTACT_ID}
                  component={Select}
                  options={options}
                  label="Vendor Contact"
                  required
                />
              </Col>
              <Col md={3}>
                <PaymentTerms getInitialFieldValue={getInitialFieldValue} />
              </Col>
            </FormRow>
            {contact === PORTAL_PURCHASE && (
              <FormRow>
                <Col md={12}>
                  <div className="form-group">
                    <Field
                      component={FormInput}
                      disabled={get(company, WEBSITE)}
                      name="company.website"
                      label={properCase(WEBSITE)}
                      required
                    />
                  </div>
                </Col>
              </FormRow>
            )}
            {contact === "Add" && (
              <FormRow>
                <Col md={6}>
                  <div className="form-group">
                    <Field
                      name="contact.name"
                      component={FormInput}
                      label="Contact Name"
                      required
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="form-group">
                    <Field
                      name="contact.email"
                      component={FormInput}
                      label="Contact Email"
                      required
                    />
                  </div>
                </Col>
              </FormRow>
            )}
          </div>
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  setLot: PropTypes.func,
  lot: PropTypes.instanceOf(Object)
};

const selector = formValueSelector(formName);

export default connect(
  state => ({
    contact: selector(state, CONTACT_ID),
    getInitialFieldValue: field =>
      _.get(getFormInitialValues(formName)(state), field)
  }),
  dispatch => ({
    onSubmit: data => dispatch(actions.update(data)),
    searchCompanies: filter => dispatch(actions.searchCompanies(filter)),
    setFieldValue: field => val => dispatch(change(formName, field, val))
  })
)(
  form({
    form: formName,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/Detail/EditVendor/Form.jsx